





























































import { Vue, Component, Prop, Emit, Ref, Model } from 'vue-property-decorator'
import config from '../../config'
import { getFileType } from '../../utils/file'

export interface FileResp {
  name: string;
  url: string;
  verifyStatus?: boolean;
  ifNew?: number;
  uid?: number;
  status?: 'ready' | 'uploading' | 'success' | 'fail';
  [key: string]: any;
}

export interface RequestOptions {
    headers: Record<string, any>;
    withCredentials: boolean;
    file: File;
    data: any;
    filename: string;
    action: string;
    onProgress: (e: { percent: number }) => void;
    onSuccess: (res: any) => void;
    onError: (err: Error) => void;
}

export interface Request {
  (options: RequestOptions): Request;
}

@Component({
  components: { }
})
export default class GlpUpload extends Vue {
  @Prop(Boolean) disabled!: boolean

  @Prop({ type: String, default: '#' }) action!: string

  @Prop(Function) resp!: (response: any) => FileResp

  @Prop(Function) request!: Request

  @Prop(Function) onView!: any

  @Prop(Boolean) editControl!: any

  @Prop({ type: String, default: 'card' }) type!: 'card' | 'list'

  @Prop({ type: String, default: 'image/jpeg,image/jpg,image/png,.pdf,.xlsx,.docx' }) accept!: string

  @Prop(Number) limit!: number

  @Prop(String) maxSize!: string // 20K 1M

  @Prop(Function) beforeUpload!: (file: any, fileList: any[]) => boolean | Promise<any>

  @Prop(Boolean) inline!: boolean // 行内模式 只有list风格有行内模式

  @Prop(Boolean) multiple!: boolean

  @Model('input', { type: Array }) readonly value!: FileResp[]

  @Emit() input (value: FileResp[]) {}

  @Ref() upload!: any

  @Ref() image!: any

  imageUrl = ''

  // visible = false

  get imageUrls () {
    return this.imageUrl ? [this.imageUrl] : []
  }

  get disabledCls () {
    return this.disabled ? 'glp-upload--disabled' : ''
  }

  get inlineCls () {
    return this.inline ? 'glp-upload--inline' : ''
  }

  showTips (file: any) {
    if (file.isDetail) {
      return false
    }
    if (String(file.verifyStatus) === '3' && !this.editControl) {
      return true
    }
  }

  showDelete (file: any) {
    if (this.disabled) {
      return false
    }
    if (this.editControl) {
      return true
    }
    if ((file.status === 'success' || file.status === 'fail') && !file.id) {
      return true
    }

    if (file.verifyStatus === 2) {
      return false
    }

    if (file.verifyStatus === 1) {
      return true
    }

    if (file.verifyStatus === 3) {
      return true
    }
    return false
  }

  get props () {
    return {
      listType: this.type === 'card' ? 'picture-card' : undefined,
      onSuccess: this.successFn,
      fileList: this.value,
      action: this.action,
      disabled: this.disabled,
      httpRequest: this.request,
      accept: this.accept,
      limit: this.limit,
      onExceed: this.onExcced,
      beforeUpload: this.defaultBeforeUpload,
      multiple: this.multiple
    }
  }

  successFn (response: any, file: any, fileList: any[]) {
    const ret = fileList.filter((v: any) => ['success', 'uploading'].includes(v.status)).map((v: any) => {
      const url = v.response ? (this.resp ? this.resp(v.response) : v.response)?.url : v.url
      return {
        uid: v.uid,
        id: v.id,
        status: v.status,
        name: v.name,
        ifNew: v.ifNew,
        checked: false,
        verifyStatus: v.verifyStatus,
        url
      }
    })
    this.input(ret)
  }

  onRemove (file: any) {
    this.input(this.value.filter((v: any) => v.uid !== file.uid))
  }

  onPreview (file: any) {
    if (this.onView) {
      this.onView(file)
      return
    }
    if (this.getContentType(file.name) === 'pdf') config.previewPdf(file.url)
    else if (['word', 'excel', 'ppt'].includes(this.getContentType(file.name))) config.previewOffice(file.url)
    else if (this.getContentType(file.name) === 'image') {
      this.imageUrl = file.url
      // this.visible = true
      this.image.clickHandler()
      this.$nextTick(() => {
        this.image.clickHandler()
      })
    } else {
      this.$message.info('尚不支持预览该类型文件')
    }
  }

  onDownload (file: any) {
    const { url, name } = file
    config.download(name, url)
  }

  onExcced () {
    this.$message.warning(`最多只能上传 ${this.limit} 个文件`)
  }

  defaultBeforeUpload (file: any) {
    let ret!: Promise<any>
    if (this.beforeUpload) {
      const fileList = this.upload?.uploadFiles
      const result = this.beforeUpload(file, fileList)
      if (!(result instanceof Promise)) ret = result ? Promise.resolve(result) : Promise.reject(result)
      else {
        ret = result
      }
    } else ret = Promise.resolve()
    return ret.then(() => {
      if (!this.maxSize) return Promise.resolve()
      const max = this.maxSize.replace(/[MK]/g, (_, c) => _ === 'K' ? '*1024' : '*1048576').split('*').reduce((t, n: any) => t * n, 1)
      if (file.size > max) {
        this.$message.warning(`文件大小不能超过${this.maxSize}`)
        return Promise.reject(new Error(''))
      }
      return Promise.resolve()
    })
  }

  getContentType (name: string): 'image' | 'pdf' | 'word' | 'excel' | 'ppt' | 'other' {
    return getFileType(name)
  }
}
